<template lang="pug">
	.audio-tracker-insertion--audio-insertion-details.flex-col(v-if="record")
		.flex-col
			.flex-row.grey.upper.small-font.margin-top {{$tCaption('Title')}}
			DxTextBox(:value.sync="record.name")
		template(v-if="record.parentId")
			.grey.upper.small-font.margin-top {{$tCaption('Rule')}}
			Dropdown(
				:getTotal="(data) => null",
				:getItems="(data) => data",
				:getData="loadRules",
				:columns="[{ dataField: 'Name', caption: $tCaption('Rule') }]",
				displayExpr="Name",
				valueExpr="Oid",
				:placeholder="$tCaption('Rule')",
				v-model="record.eventRule && record.eventRule.Oid",
				:showColumnHeaders="false",
				:filtersVisible="false",
				:searchVisible="true",
				:multiple="false",
				:preloadedObjects="[record.eventRule]",
				@select-data="v => record.eventRule = v")
</template>

<script>
	import _ from 'lodash';
	import Dropdown from 'app-core/Dropdown.vue';
	import DxTextBox from 'devextreme-vue/text-box';

	export default {
		translationCategory: 'insertion.Detail',
		name: 'audio-editor-insertion--audio-insertion-details',
		components: { Dropdown, DxTextBox },
		props: ['track', 'tracker'],
		data() {
			return {
				record: null
			};
		},
		watch: {
			track() {
				this.setRecord();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.audioInsertionDetails = this;
			this.setRecord();
		},
		destroyed() {
		},
		methods: {
			setRecord() {
				if (!this.track) return;
				let insertion = this.$Data.formatObjectToLowerCase(this.track.insertion);
				this.record = {
					...insertion,
					subInsertions: this.track.insertion.SubInsertions && this.track.insertion.SubInsertions.map(f => this.$Data.formatObjectToLowerCase(f)) || [],
					buffer: this.tracker.tracksBuffers[this.track.id],
					base64: this.tracker.tracksBase64[this.track.id],
				};
			},	
			loadRules(pageIndex, limit, opts) {
				return this.$Data.getRules(pageIndex, limit, opts);
			},
			assignValues() {
				_.assign(this.track.insertion, {
					Name: this.record.name,
					EventRule: this.record.eventRule
				})
			}
		}
	};
</script>

<style lang='scss'>
	.audio-tracker-insertion--audio-insertion-details {
	}
</style>
